import React, { useState, useEffect } from 'react';
import EditableField from './EditableField';
import NotifyField from './NotifyField';

const ContactForm = ({ data, dataFromForm }) => {
  const [formData, setFormData] = useState({
    from: 'Queue Me Up'
  });
  const [errors, setErrors] = useState({});
  const [ifEditing, setIfEditing] = useState({
    from: false,
    subject: false,
    message: false,
  });

  useEffect(() => {
    if (data) {
      setFormData((prev) => ({ ...prev, ...data }));
    }
  }, [data]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = (field) => {
    setFormData((prev) => ({ ...prev, [field]: formData[field] }));
    dataFromForm(formData);
    setIfEditing((prev) => ({ ...prev, [field]: false }));
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.from) newErrors.from = 'From Name is required';
    if (!formData.subject) newErrors.subject = 'Subject is required';
    if (!formData.message) newErrors.message = 'Message is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onEditHandler = (id) => {
    setIfEditing((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <form style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
      {!ifEditing.from ? (
        <NotifyField
          text={formData.from}
          label={'From: '}
          onEditHandler={() => onEditHandler('from')}
        ></NotifyField>
      ) : (
        <EditableField
          value={formData.from}
          label={'From: '}
          name={'from'}
          onChangeHandler={handleChange}
          handleSave={() => handleSave('from')}
        />
      )}
      {!ifEditing.subject ? (
        <NotifyField
          text={formData.subject}
          label={'Subject: '}
          onEditHandler={() => onEditHandler('subject')}
        ></NotifyField>
      ) : (
        <EditableField
          value={formData.subject}
          name={'subject'}
          label={'Subject: '}
          onChangeHandler={handleChange}
          handleSave={() => handleSave('subject')}
        />
      )}
      {!ifEditing.message ? (
        <NotifyField
          text={formData.message}
          label={'Message: '}
          onEditHandler={() => onEditHandler('message')}
        ></NotifyField>
      ) : (
        <EditableField
          value={formData.message}
          label={'Message: '}
          name={'message'}
          onChangeHandler={handleChange}
          handleSave={() => handleSave('message')}
        />
      )}
    </form>
  );
};

export default ContactForm;
